import { useMutation } from "@tanstack/react-query";
import api from "@/lib/api-client";
import { toast } from "react-toastify";

const sendEmail = async ({ data, executeRecaptcha }) => {
    if (!executeRecaptcha) return;
    const captchaToken = await executeRecaptcha("submit_form");

    const payload = {
        ...data,
    };

    const res = await api.post("/Contact", payload, {
        headers: {
            "x-captcha-token": captchaToken,
        },
    });

    return res.data;
};

export const useSendContactRequest = () => {
    return useMutation({
        mutationFn: sendEmail,
        retry: 1,
        onSuccess: () => {
            toast.success("Contact request sent");
        },
        onError: () => {
            toast.error("Error sending request");
        },
    });
};
